export default __webpack_public_path__ + "static/media/Icon-Arrow_Red.2e004fa8.svg";